export const primaryNavigation = [
  { id: 1, title: 'For Providers', url: '/providers' },
  { id: 2, title: 'For Patients', url: '/patients' },
  { 
    id: 3, 
    title: 'Product', 
    type: 'dropdown',
    items: [
      { id: 31, title: 'Features', url: '/features' },
      { id: 32, title: 'Security', url: '/security' },
      { id: 33, title: 'Pricing', url: '/pricing' }
    ]
  },
  { id: 4, title: 'Blog', url: '/blog' },
  { id: 5, title: 'About', url: '/about' }
];

export const socialLinks = [
  { id: 1, title: 'LinkedIn', url: 'https://linkedin.com/company/halespring', target: '_blank' },
  { id: 2, title: 'Instagram', url: 'https://instagram.com/halespringhq', target: '_blank' },
  { id: 3, title: 'Facebook', url: 'https://facebook.com/profile.php?id=61556796682602', target: '_blank' }
];

// Default export for navigationSlice compatibility
const navigationConfig = [];
export default navigationConfig;